const confs = {
	IST:"Information and Software Technology",
	TSE:"IEEE Transactions on Software Engineering",
	JSEP:"Journal of Software: Evolution and Process",
	SEKE:"International Conference on Software Engineering and Knowledge Engineering",
	JSS:"Journal of Systems and Software",
	JCST:"Journal of Computer Science and Technology",
	COMPSAC:"IEEE Annual Computer Software and Applications Conference",
	TOSEM:"ACM Transactions on Software Engineering and Methodology",
	TR:"IEEE Transactions on Reliability",
	FSE:"ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering",
	FSE_I:"ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering (Industry Track)",
	TechDebt:"International Conference on Technical Debt",
	APSEC:"Asia-Pacific Software Engineering Conference",
	ISSRE:"IEEE International Symposium on Software Reliability Engineering",
	SANER:"IEEE International Conference on Software Analysis, Evolution and Reengineering",
	IET:"IET Software",
	EMSE:"Empirical Software Engineering",
	ICPC:"International Conference on Program Comprehension",
	MSR:"International Conference on Mining Software Repositories",
	ASEJ:"Automated Software Engineering Journal",
	ASE:"International Conference on Automated Software Engineering",
	ASE_I:"International Conference on Automated Software Engineering (Industry Track)",
	Internetware:"Asia-Pacific Symposium on Internetware",
	CEISEE:"China-Europe International Symposium on Software Engineering Education",
	ISSTA:"ACM SIGSOFT International Symposium on Software Testing and Analysis",
	ICSE:"International Conference on Software Engineering",
	ICSE_D:"International Conference on Software Engineering (Demonstrations Track)",
	ACL_F:"Annual Meeting of the Association for Computational Linguistics (Findings)"
}
export default confs